<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-09-10                                                         -
  ----------------------------------------------------------------------------->

<template>
  <b-container style="margin-top: 70px">
    <b-row>
      <b-col sm="12" md="12" lg="8" xl="8">
        <configure-accessory-dialog :template-version="template_version"
                                    :quote-product="quote_product"
                                    :attributes-list="dialogAttributesList"
                                    :prices-list="dialogPricesList">
        </configure-accessory-dialog>
      </b-col>
      <b-col sm="12" md="12" lg="4" xl="4">
        <div class="position-sticky" style="top:70px">
          <configure-accessory-summary :template-version="template_version"
                                       :quote-product="quote_product"
                                       :price-name="summaryPriceName">
          </configure-accessory-summary>
          <configuration-dialog-buttons :quote-product="quote_product" :is-public="isPublic"></configuration-dialog-buttons>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ConfigureAccessoryDialog from "./configure-accessory-dialog.vue";
import ConfigureAccessorySummary from "./configure-accessory-summary.vue";
import ConfigurationDialogButtons from "./configuration-dialog-buttons.vue";
import ConfigureMixin from "./configure-mixin";

export default {
  name: "configure-accessories",
  mixins: [ConfigureMixin],
  components: {
    ConfigurationDialogButtons,
    ConfigureAccessorySummary,
    ConfigureAccessoryDialog
  },
  props: {
    dialogPricesList:{
      type:Array,
      default(){
        return [];
      }
    },
    dialogAttributesList:{
      type: Array,
      default(){
        return [];
      }
    },
    summaryPriceName:{
      type:String,
      required: true
    },
    isPublic:{
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>
